export const moveArrIndexTo = (arr: Array<any>, from: number, to: number) => {
  arr.splice(to, 0, arr.splice(from, 1)[0])
}
